import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { getSubscriptionStatus } from '../Services/SubscriptionApi';

const SubscriptionContext = createContext({ hasAccess: null });

export const SubscriptionProvider = ({ children }) => {
    const [hasAccess, setHasAccess] = useState(() => {
        const cached = localStorage.getItem('hasSubscriptionAccess');
        if (cached === 'true') return true;
        if (cached === 'false') return false;
        return null;
    });

    const checkAccess = useCallback(async () => {
        try {
            const data = await getSubscriptionStatus();
            const access =
                data?.hasSubscription &&
                ['active', 'trialing', 'cancelling'].includes(data?.status);
            const result = !!access;
            setHasAccess(result);
            localStorage.setItem('hasSubscriptionAccess', String(result));
        } catch {
            setHasAccess(false);
            localStorage.setItem('hasSubscriptionAccess', 'false');
        }
    }, []);

    useEffect(() => {
        checkAccess();
    }, [checkAccess]);

    const value = useMemo(() => ({ hasAccess, refreshSubscription: checkAccess }), [hasAccess, checkAccess]);

    return (
        <SubscriptionContext.Provider value={value}>
            {children}
        </SubscriptionContext.Provider>
    );
};

SubscriptionProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export const useSubscription = () => useContext(SubscriptionContext);
